import { useState } from "react";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Lock, User } from "lucide-react";
import AuthService from "../service/AuthService";
import { useToastContext } from "../provider/ToastContext";
import { AxiosError } from "axios";
import { Link } from "react-router-dom";
import { useLoadingContext } from "../provider/LoadingProvider";

interface LoginPageProps {
  onLogin: () => void;
}

const authService = new AuthService();
export function LoginPage({ onLogin }: LoginPageProps) {
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const { msgAlerta, msgErro, msgSucesso, msgInfo } = useToastContext();
  const { startLoading, stopLoading } = useLoadingContext();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (user && password) {
      startLoading();
      authService.logar(user, password).then(data => {
        localStorage.setItem('token', data.token);
        stopLoading();
        onLogin();
      }).catch((err: AxiosError) => {
        stopLoading();
        console.log(err)
        if (err.status === 409) {
          msgAlerta("Não foi possível efetuar o login", "Seu usuário não tem senha definida.");
        }
        if (err.status === 403) {
          msgAlerta("Acesso negado", "Email ou senha inválidos.");
        }
      });
    }
  };

  return (
    <div className="gradient-bg flex align-items-center justify-content-center p-4">
      <Card className="login-card shadow-4">
        <div className="text-center mb-4">
          <div className="login-icon">
            <img src="/logo.png" alt="Logo" width={80} />
          </div>
          <h2 className="mb-2">Portal do Cliente</h2>
          <p className="text-muted">Faça login para acessar sua conta</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="user" className="block mb-2">
              E-mail ou documento (CPF/CNPJ, apenas números)
            </label>
            <span className="p-input-icon-left w-full">
              <User size={20} style={{ marginLeft: 8, marginRight: 8 }} />
              <InputText
                id="user"
                value={user}
                placeholder="Email, CPF ou CNPJ"
                onChange={(e) => setUser(e.target.value)}
                className="w-full"
                style={{ paddingLeft: 32 }}
                required
              />
            </span>
          </div>

          <div className="mb-3">
            <label htmlFor="password" className="block mb-2">
              Senha
            </label>
            <span className="p-input-icon-left w-full">
              <Lock size={20} style={{ marginLeft: 8, marginRight: 8 }} />
              <InputText
                id="password"
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full"
                style={{ paddingLeft: 32 }}
                required
              />
            </span>
          </div>

          <Button
            type="submit"
            label="Entrar"
            className="w-full mb-3"
          />

          <div className="text-center">
            <Link to={"/solicitarTrocaSenha"} className="text-primary no-underline">
              Esqueceu sua senha?
            </Link>
          </div>
        </form>
      </Card>
    </div>
  );
}
